import { type } from '@/utils/type'


export const COVERAGEITERATION_REQUEST = type('COVERAGEITERATION_REQUEST')
export const COVERAGEITERATION_SUCCESS = type('COVERAGEITERATION_SUCCESS')
export const COVERAGEITERATION_ERROR = type('COVERAGEITERATION_ERROR')

export const COVERAGEITERATION_ENSURE_LIST = type('COVERAGEITERATION_ENSURE_LIST')

export const COVERAGEITERATION_SELECT_DETAIL_REQUEST = type('COVERAGEITERATION_SELECT_DETAIL_REQUEST')
export const COVERAGEITERATION_SELECT_DETAIL_SUCCESS = type('COVERAGEITERATION_SELECT_DETAIL_SUCCESS')
export const COVERAGEITERATION_SELECT_DETAIL_ERROR = type('COVERAGEITERATION_SELECT_DETAIL_ERROR')
export const COVERAGEITERATION_SELECT_DETAIL = type('COVERAGEITERATION_SELECT_DETAIL')

export const COVERAGEITERATION_SAVE_REQUEST = type('COVERAGEITERATION_SAVE_REQUEST')
export const COVERAGEITERATION_SAVE_SUCCESS = type('COVERAGEITERATION_SAVE_SUCCESS')
export const COVERAGEITERATION_SAVE_ERROR = type('COVERAGEITERATION_SAVE_ERROR')

export const COVERAGEITERATION_UPDATE_MODIFIED_ADM = type('COVERAGEITERATION_UPDATE_MODIFIED_ADM')
export const COVERAGEITERATION_CANCEL_MODIFIED_ADM = type('COVERAGEITERATION_CANCEL_MODIFIED_ADM')

export const COVERAGEITERATION_UPDATE_FILTER_ADM = type('COVERAGEITERATION_UPDATE_FILTER_ADM')
export const COVERAGEITERATION_PROGRESSION_REQUEST = type('COVERAGEITERATION_PROGRESSION_REQUEST')
export const COVERAGEITERATION_PROGRESSION_SUCCESS = type('COVERAGEITERATION_PROGRESSION_SUCCESS')
export const COVERAGEITERATION_PROGRESSION_ERROR = type('COVERAGEITERATION_PROGRESSION_ERROR')

export const COVERAGEITERATION_DELETE_REQUEST = type('COVERAGEITERATION_DELETE_REQUEST')
export const COVERAGEITERATION_DELETE_SUCCESS = type('COVERAGEITERATION_DELETE_SUCCESS')
export const COVERAGEITERATION_DELETE_ERROR = type('COVERAGEITERATION_DELETE_ERROR')


export const COVERAGEITERATION_ENSURE_DATA_SCIENCE = type('COVERAGEITERATION_ENSURE_DATA_SCIENCE')
export const COVERAGEITERATION_DATA_SCIENCE_REQUEST = type('COVERAGEITERATION_DATA_SCIENCE_REQUEST')
export const COVERAGEITERATION_DATA_SCIENCE_SUCCESS = type('COVERAGEITERATION_DATA_SCIENCE_SUCCESS')
export const COVERAGEITERATION_DATA_SCIENCE_ERROR = type('COVERAGEITERATION_DATA_SCIENCE_ERROR')
